module.exports = __webpack_public_path__ + "img/grey.02f6eae8.jpeg";